import React, {useState} from 'react';
import '../App.css';
import {
    Row,
    Col
} from 'bootstrap-4-react';

function TexturesRow() {

    const textures = [
        {
            id: 1,
            title: 'Арт-бетон',
            img: '/textures/art-beton.jpg',
            img_big: '/textures/textures_big/art-beton.jpg',
            color: 'white'
        },
        {
            id: 2,
            title: 'Американка',
            img: '/textures/americanka.jpg',
            img_big: '/textures/textures_big/americanka.jpg',
            color: 'white'
        },
        {
            id: 3,
            title: 'Карта Мира',
            img: '/textures/map.jpg',
            img_big: '/textures/textures_big/map.jpg',
            color: 'rgb(52, 52, 52)'
        },
        {
            id: 4,
            title: 'Splash',
            img: '/textures/splash.jpg',
            img_big: '/textures/textures_big/splash.jpg',
            color: 'white'
        },

        {
            id: 6,
            title: 'Травертин',
            img: '/textures/travertin.jpg',
            img_big: '/textures/textures_big/travertin.jpg',
            color: 'white'
        },
    ]

    const [selectedTexture, setSelectedTexture] = useState(textures[0])

    return (
        <Row id="tRow" className={'programItem'}
             style={{backgroundImage: `url(${process.env.PUBLIC_URL + selectedTexture.img_big})`,
                 backgroundSize: 'cover', backgroundColor: 'grey',
                 color: selectedTexture.color
             }}>
            <Col col="md-4">
                <h2 className="subtitle rowSubtitle">Как механизированно наносить популярные фактуры</h2>
                <p>Мы расскажем из каких этапов состоит процесс механизированного нанесения и поделимся деталями</p>
                <div className={'texturesSelector'}>
                    {
                        textures.map(item => {
                            return (
                                <div className={(selectedTexture.id === item.id) ? 'textureItem selectedTexture' : 'textureItem'} key={item.id} onClick={() => setSelectedTexture(item)}>
                                    <div className={'textureItemContent'}>
                                        <img src={process.env.PUBLIC_URL + item.img} alt={item.title} height={60}/>
                                        <small>{item.title}</small>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </Col>
            <Col col="md-8">
                <div className={'textureWrap'} >

                </div>
            </Col>
        </Row>


    );
}

export default TexturesRow;
